import pupg from "../../assets/img/pupg.png";
import khan_wars from "../../assets/img/khan-wars.png";
import ps from "../../assets/img/playstation.png";

const cardListData = [
    {
        title: "الأكثر مبيعاً",
        listStyle: 1,
        viewMore: "false",
        items: [
            {
                id: "cl_1_1",
                title: "يلا لودو",
                link: "#",
                linkTxt: "عرض كل البطاقات",
                img: pupg,
                stars: 4,
                dimStars: 1,
                wishList: false,
                cart: false
            },
            {
                id: "cl_1_2",
                title: "يلا لودو",
                link: "#",
                linkTxt: "عرض كل البطاقات",
                img: pupg,
                stars: 5,
                dimStars: 0,
                wishList: false,
                cart: true
            },
            {
                id: "cl_1_3",
                title: "يلا لودو",
                link: "#",
                linkTxt: "عرض كل البطاقات",
                img: pupg,
                stars: 3,
                dimStars: 2,
                wishList: true,
                cart: false
            },
            {
                id: "cl_1_4",
                title: "يلا لودو",
                link: "#",
                linkTxt: "عرض كل البطاقات",
                img: pupg,
                stars: 5,
                dimStars: 0,
                wishList: true,
                cart: true
            },
            {
                id: "cl_1_5",
                title: "يلا لودو",
                link: "#",
                linkTxt: "عرض كل البطاقات",
                img: pupg,
                stars: 5,
                dimStars: 0,
                wishList: false,
                cart: false
            },
            {
                id: "cl_1_6",
                title: "يلا لودو",
                link: "#",
                linkTxt: "عرض كل البطاقات",
                img: pupg,
                stars: 5,
                dimStars: 0,
                wishList: false,
                cart: false
            }
        ]
    },
    {
        title: "أحدث المنتجات",
        listStyle: 2,
        viewMore: "false",
        items: [
            {
                id: "cl_2_1",
                title: "بطاقات حرب الملوك",
                link: "#",
                linkTxt: "عرض كل البطاقات",
                img: khan_wars,
                stars: 4,
                dimStars: 1,
                wishList: false,
                cart: false
            },
            {
                id: "cl_2_2",
                title: "بطاقات حرب الملوك",
                link: "#",
                linkTxt: "عرض كل البطاقات",
                img: khan_wars,
                stars: 5,
                dimStars: 0,
                wishList: false,
                cart: true
            },
            {
                id: "cl_2_3",
                title: "بطاقات حرب الملوك",
                link: "#",
                linkTxt: "عرض كل البطاقات",
                img: khan_wars,
                stars: 3,
                dimStars: 2,
                wishList: true,
                cart: false
            },
            {
                id: "cl_2_4",
                title: "بطاقات حرب الملوك",
                link: "#",
                linkTxt: "عرض كل البطاقات",
                img: khan_wars,
                stars: 5,
                dimStars: 0,
                wishList: true,
                cart: true
            },
            {
                id: "cl_2_5",
                title: "بطاقات حرب الملوك",
                link: "#",
                linkTxt: "عرض كل البطاقات",
                img: khan_wars,
                stars: 5,
                dimStars: 0,
                wishList: false,
                cart: false
            },
            {
                id: "cl_2_6",
                title: "بطاقات حرب الملوك",
                link: "#",
                linkTxt: "عرض كل البطاقات",
                img: khan_wars,
                stars: 5,
                dimStars: 0,
                wishList: false,
                cart: false
            }
        ]
    },
    {
        title: "منتجات قد تعجبك",
        listStyle: 3,
        viewMore: "false",
        items: [
            {
                id: "cl_3_1",
                title: "بطاقات شحن موبايلى",
                link: "#",
                linkTxt: "عرض كل البطاقات",
                img: ps,
                stars: 4,
                dimStars: 1,
                wishList: false,
                cart: false
            },
            {
                id: "cl_3_2",
                title: "بطاقات شحن موبايلى",
                link: "#",
                linkTxt: "عرض كل البطاقات",
                img: ps,
                stars: 5,
                dimStars: 0,
                wishList: false,
                cart: true
            },
            {
                id: "cl_3_3",
                title: "بطاقات شحن موبايلى",
                link: "#",
                linkTxt: "عرض كل البطاقات",
                img: ps,
                stars: 3,
                dimStars: 2,
                wishList: true,
                cart: false
            },
            {
                id: "cl_3_4",
                title: "بطاقات شحن موبايلى",
                link: "#",
                linkTxt: "عرض كل البطاقات",
                img: ps,
                stars: 5,
                dimStars: 0,
                wishList: true,
                cart: true
            },
            {
                id: "cl_3_5",
                title: "بطاقات شحن موبايلى",
                link: "#",
                linkTxt: "عرض كل البطاقات",
                img: ps,
                stars: 5,
                dimStars: 0,
                wishList: false,
                cart: false
            },
            {
                id: "cl_3_6",
                title: "بطاقات شحن موبايلى",
                link: "#",
                linkTxt: "عرض كل البطاقات",
                img: ps,
                stars: 5,
                dimStars: 0,
                wishList: false,
                cart: false
            }
        ]
    }
];
export default cardListData;
